import { styled } from '@mui/material';
import { tokens } from './styles';

/**
 * Estilos só das variações da tela (ConfigureEquipmentMockup2 e 3): o bloco
 * "Produtos adicionais" da coluna da direita. O resto vem de ./styles.
 */
const { GREEN, BORDER, DIVIDER, SURFACE, TITLE, TEXT, RADIUS, MOBILE } = tokens;

export const ExtrasTitle = styled('h3')({
  margin: 0,
  fontSize: '16px',
  fontWeight: 700,
  letterSpacing: '-0.1px',
  color: TITLE,
});

// ─── Variação 2: carrossel horizontal ─────────────────────────────────────────

/**
 * Corpo sem rolagem vertical: a descrição ocupa o que sobra e rola só ela, se
 * o texto for longo; "Produtos adicionais" tem altura fixa e compacta.
 */
export const FitBody = styled('div')({
  flex: '1 1 auto',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: '16px 20px 14px',
  overflow: 'hidden',
});

export const FitHead = styled('div')({
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
});

export const ExtrasBlock = styled('div')({
  flex: '0 0 auto',
});

export const ExtrasEmpty = styled('p')({
  margin: 0,
  padding: '10px 0 4px',
  fontSize: '13px',
  color: tokens.MUTED,
});

export const ExtrasHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  marginBottom: '8px',
});

export const RailButtons = styled('div')({
  display: 'flex',
  gap: '8px',
  '& .MuiIconButton-root': {
    width: '28px',
    height: '28px',
    border: `1px solid ${BORDER}`,
    color: TEXT,
    background: '#fff',
  },
  '& .MuiIconButton-root:hover': { borderColor: GREEN, color: GREEN },
});

export const ExtrasRail = styled('div')({
  display: 'flex',
  gap: '12px',
  overflowX: 'auto',
  paddingBottom: '6px',
  scrollSnapType: 'x proximity',
});

/** Card do carrossel: foto em cima, nome embaixo. */
export const ExtraCard = styled('div')({
  flex: '0 0 auto',
  width: '150px',
  borderRadius: RADIUS,
  border: `1px solid ${BORDER}`,
  background: '#fff',
  overflow: 'hidden',
  scrollSnapAlign: 'start',
  '& > div:first-of-type': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '84px',
    background: SURFACE,
    color: '#b3bbb5',
  },
  '& img': { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' },
  '& svg': { fontSize: '30px' },
  '& strong': {
    display: 'block',
    padding: '8px 8px',
    fontSize: '12.5px',
    fontWeight: 600,
    lineHeight: 1.35,
    textAlign: 'center',
    color: TITLE,
  },
});

// ─── Variação 3: coluna vertical separada ─────────────────────────────────────

/** Descrição à esquerda e "Produtos adicionais" à direita, cada um com a sua rolagem. */
export const SplitBody = styled('div')({
  flex: '1 1 auto',
  minHeight: 0,
  display: 'flex',
  gap: '20px',
  padding: '18px 20px',
  [MOBILE]: { flexDirection: 'column', overflowY: 'auto' },
});

export const SplitMain = styled('div')({
  flex: '1 1 auto',
  minWidth: 0,
  overflowY: 'auto',
  [MOBILE]: { overflowY: 'visible' },
});

export const ExtrasColumn = styled('div')({
  flex: '0 0 300px',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '18px',
  borderLeft: `1px solid ${DIVIDER}`,
  [MOBILE]: {
    flex: '0 0 auto',
    paddingLeft: 0,
    paddingTop: '16px',
    borderLeft: 'none',
    borderTop: `1px solid ${DIVIDER}`,
  },
});

/** Linha da coluna: foto à esquerda, nome à direita. */
export const ExtraRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginTop: '12px',
  padding: '8px',
  borderRadius: RADIUS,
  border: `1px solid ${BORDER}`,
  background: '#fff',
  '& > div': {
    flex: '0 0 96px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '96px',
    borderRadius: '6px',
    background: SURFACE,
    color: '#b3bbb5',
    overflow: 'hidden',
  },
  '& img': { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' },
  '& svg': { fontSize: '34px' },
  '& strong': {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.35,
    color: TITLE,
  },
});

/** Lista rolável sob o título fixo "Produtos adicionais". */
export const ExtrasList = styled('div')({
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  paddingBottom: '4px',
  [MOBILE]: { overflowY: 'visible' },
});
